import {isEmpty} from 'lodash';
import utilityfunctions from '../../util/utilityfunctions';
import {UserType} from '../../util/uiconstants';

function getEngagementDescription(userType, engagement) {
	const isExternalMember = userType !== UserType.Member;

	if (isExternalMember && !isEmpty(engagement.clientEngagementDescription)) {
		return engagement.clientEngagementDescription?.toString();
	} else {
		return engagement.engagementDescription?.toString();
	}
}

export default (engagements, userType) => {
	const sortEngagements = utilityfunctions.sortListData(engagements, 'engagementDescription');
	let normalizeEngagements = [];

	if (Array.isArray(sortEngagements)) {
		normalizeEngagements = sortEngagements.map((engagement) => {
			return {
				label: engagement.engagementDescription?.toString(),
				value: engagement.canvasEngagementId,
				id: engagement.canvasEngagementId,
				engagementId: engagement.canvasEngagementId,
				description: getEngagementDescription(userType, engagement),
				countryId: engagement.countryId,
				countryName: engagement.countryName,
				groupRoleId: engagement.gaRoleTypeID,
				gaRoleTypeName: engagement.gaRoleTypeName,
				engagementStatus: engagement.engagementStatus,
				selected: false,
				disabled: false
			};
		});
	}
	return normalizeEngagements;
};
